export default {"src":"/_next/static/media/person.bd929165.svg","height":24,"width":24};